import {useState} from 'react';
import type {FCWithChildren} from 'types';
import {logError} from 'logging';
import {useLocalization} from 'localization';
import {useAuthState} from 'services/auth/hooks/useAuthState';
import {ErrorMessage, Text} from 'components/text';
import {AppAnon} from './AppAnon';

export const AuthGate: FCWithChildren = ({children}) => {
  const {isLoading, error, login} = useAuthState();
  const {t} = useLocalization();
  const [retried, setRetried] = useState(false);

  if (isLoading) {
    return (
      <AppAnon>
        <Text variant={'body2'} component={'p'}>
          {t('page.login.redirect')}
        </Text>
      </AppAnon>
    );
  }
  if (error) {
    logError('AuthGate error', {error});

    if (!retried) {
      setRetried(true);
      login();
      return;
    }

    return (
      <AppAnon>
        <ErrorMessage message={`AuthGate error: ${error.message}`} />
      </AppAnon>
    );
  }

  return <>{children}</>;
};
